import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BinderDialogService } from '../app/binder-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class InviteService {
  private BASE_URL = environment.landmark_API_URL + '/invite';
  inviteId = signal<number|null>(null);

  constructor(private http: HttpClient, private binderDialogService: BinderDialogService) { }

  getInvite(inviteId: number) {
    return this.http.get(`${this.BASE_URL}/${inviteId}`);
  }

  acceptInvite(inviteId: number) {
    return this.http.put(`${this.BASE_URL}/accept/${inviteId}`, {});
  }

  declineInvite(inviteId: number) {
    return this.http.put(`${this.BASE_URL}/decline/${inviteId}`, {});
  }

  setInviteId(inviteId: number | null) {
    this.inviteId.set(inviteId);
  }

  openInviteReview(inviteId: number | null) {
    if(inviteId) {
      this.setInviteId(inviteId);
      this.binderDialogService.toggleDialog('Invite', 'invite', true);
    }
  }
}
